import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { ProcedureStepSettingsFieldsViewTopBar } from "./TopBar"

export const procedureStepSettingsFieldsViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: ProcedureStepSettingsFieldsViewTopBar,
}
